// Legacy exports (for backward compatibility)
export const BASE_URL = process.env.REACT_APP_BASE_URL || "noENV";
export const DOCS_URL = process.env.REACT_APP_DOCS_URL || "noENV"

// Helper functions
export const isDevelopment = () => process.env.REACT_APP_ENV === 'development';
export const isProduction = () => process.env.REACT_APP_ENV === 'production';
export const isStaging = () => process.env.REACT_APP_ENV === 'staging';
